<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 44 44"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8 0.5H36C40.1421 0.5 43.5 3.85786 43.5 8V36C43.5 40.1421 40.1421 43.5 36 43.5H8C3.85786 43.5 0.5 40.1421 0.5 36V8C0.5 3.85786 3.85786 0.5 8 0.5Z" :fill="fill" :stroke="fill"/>
    <rect fill="#F9F9F9" height="2" rx="1" transform="rotate(-180 34 12)" width="10" x="34" y="12"/>
    <rect fill="#F9F9F9" height="2" rx="1" transform="rotate(-90 32 20)" width="10" x="32" y="20"/>
    <rect fill="#F9F9F9" height="2" rx="1" width="10" x="10" y="32"/>
    <rect fill="#F9F9F9" height="2" rx="1" transform="rotate(90 12 24)" width="10" x="12" y="24"/>
  </svg>
</template>

<script>
export default {
  name: 'ImageControlExpand',
  props: {
    width: {
      type: String,
      required: false,
      default: '44'
    },
    height: {
      type: String,
      required: false,
      default: '44'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};
</script>
